const getSeoString = (name: string) => {
  const filteredName = name
    .replace(/[^a-zA-Z0-9ĀÖ/ ]/g, "")
    .replace(/Ā/g, "A")
    .replace(/Ö/g, "O");

  return filteredName.replace(/[\s/]+/g, "-");
};

export { getSeoString };
